import path from "Router/path";

import { IActionLinkItem } from "Models/actionItem";
import { defaultCommand, ICommand, IFactoryCommand, navigateCommand } from "Helpers/actionContext";

export const actionKey = {
    home: "HOME",
    invoice: "INVOICE",
    createInvoice: "CREATE_INVOICE",
    notification: "NOTIFICATION",
    profile: "PROFILE"
}

export const actionList: Array<IActionLinkItem> = [
    { text: "Trang Chủ", icon: "ic-home", name: actionKey.home, routeLink: path.dashboard },
    { text: "Hoá Đơn", icon: "ic-invoice", name: actionKey.invoice, routeLink: path.invoice },
    { text: "Tạo Hoá Đơn", icon: "ic-create-invoice", name: actionKey.createInvoice, routeLink: path.createInvoice },
    { text: "Thông Báo", icon: "ic-alert", name: actionKey.notification, routeLink: path.notification },
    { text: "Tài Khoản", icon: "ic-account", name: actionKey.profile, routeLink: path.profile }
]

export const isActionActive = function (item: IActionLinkItem, route: any) {
    if (item.routeLink?.isDetail) {
        return route.path.includes(item.routeLink?.url);
    }
    return route.path == item.routeLink?.url;
}


export default class menuFactory implements IFactoryCommand {
    constructor(private vm: any) { }
    getCommand(name: string): ICommand {
        const actionLink = actionList.find(x => x.name == name);
        if (actionLink == null) return new defaultCommand();
        return new navigateCommand(this.vm);
    }
}
